import {rpcCall} from "../util/rpc/rpcCalls";

export default class TaskManagementService {
    loadKanbanInitial(cpSelection, workflowStatusFilter, wordFilter, onlyManageableTasks) {
        return rpcCall('TaskManagementService.getKanbanInitialData', [cpSelection, workflowStatusFilter, wordFilter, onlyManageableTasks])
    }

    loadKanbanCounters(cpSelection, workflowStatusFilter, wordFilter, onlyManageableTasks) {
        return rpcCall(
            'TaskManagementService.getKanbanInitialData',
            [cpSelection, workflowStatusFilter, wordFilter, onlyManageableTasks],
            (error) => null,
            'TaskManagementService.getKanbanInitialCounters'
        )
    }

    loadKanbanTasks(projectId, workflowStatusFilter, wordFilter, onlyManageableTasks, offset, limit) {
        return rpcCall('TaskManagementService.getTasksForKanbanView', [
            projectId,
            workflowStatusFilter,
            wordFilter,
            onlyManageableTasks,
            offset,
            limit
        ])
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/TaskManagementService.js